var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GridVideo',_vm._b({on:{"dragstart":function($event){$event.stopPropagation();$event.preventDefault();}}},'GridVideo',_vm.composedProps,false))}
var staticRenderFns = []

export { render, staticRenderFns }